'use strict';
angular.module("mcMessageDetailModule", []).
controller("mcMessageDetailCtrl", ["trsHttpService", "$state", "$scope", "$q", "modalDialog", "$rootScope",
    function(trsHttpService, $state, $scope, $q, modalDialog, $rootScope) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                messageId: JSON.parse($state.params.messageid)
            };
            $scope.data = {};
            $scope.headPic = '';
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            headPortrait();
            getNoticeDetail();
        }
        /**
         * [headPortrait description] 获取用户头像
         * @return {[type]} [description]
         */
        function headPortrait() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
         * [getNoticeDetail description] 获取消息详情
         * @return {[type]} [description]
         */
        function getNoticeDetail() {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_pm',
                methodname: 'getDocumentForTMYMessage',
                mediaDocId: $scope.status.messageId
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then((data) => {
                $rootScope.$broadcast('updateMessage', 'update')
                if (data.issuccess == 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                } else {
                    $scope.data.noticeInfo = {
                        resource: data.SOURCEGROUPNAME,
                        crtime: data.ORDERCREATETIME,
                        title: data.DOCUMENT.title,
                        content: data.DOCUMENT.htmlContent,
                        requirement: data.REQUIREMENT,
                        pmUrl: data.PMURL,
                        appendixinfo: []
                    }
                    if (angular.isDefined(data.DOCAPPENDIXS)) {
                        $scope.data.noticeInfo.appendixinfo = data.DOCAPPENDIXS.map((_item) => {
                            return {
                                FileDesc: _item.FILEDESC,
                                FileName: _item.FILENAME,
                                FileUrl: _item.FILEURL
                            }
                        });
                    }
                    defer.resolve();
                }
            });
            return defer.promise;
        }
        /**
         * [downloadFile description] 文件下载
         * @param  {[type]} file [description] 文件
         * @return {[type]}      [description]
         */
        $scope.downloadFile = function(file) {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_pm',
                methodname: 'getDownloadAddress',
                pmFileAddress: $scope.data.noticeInfo.pmUrl + file.FileUrl
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then((data) => {
                window.open(data.DETAIL);
                defer.resolve();
            });
            return defer.promise;
        }
    }
]);